exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".toolbar-header{color:#7c6a8e;font-size:12px;text-transform:uppercase;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /usr/src/sentry/node_modules/css-loader?{"minimize":true}!/usr/src/sentry/node_modules/less-loader/dist/cjs.js!./less/components/toolbarHeader.less
// module id = 1145
// module chunks = 74